import React from 'react'
import { connect } from 'react-redux'
import { bool, func } from 'prop-types'
import CLoseButtonContainer from './Buttons'
import { toggleSearchContent } from '../../../../store/Actions/UiActions'
import { Div } from '../styles/CloseSearchContent'

const checkOpen = (list, streetView, cyclorama) => {
  if (list) {
    if (streetView || cyclorama) {
      return true
    } else {
      return false
    }
  } else {
    return true
  }
}

const LargeScreenClose = props =>
  props.signs &&
  checkOpen(props.listShow, props.streetViewShow, props.cycloramaShow) && (
    <Div
      onClick={() => props.toggleSearchContent(!props.searchContent)}
      closed={!props.searchContent}
      theme={props.theme}
    >
      <CLoseButtonContainer searchContent={props.searchContent} />
    </Div>
  )

LargeScreenClose.propTypes = {
  searchContent: bool.isRequired,
  toggleSearchContent: func.isRequired,
  signs: bool.isRequired,
  listShow: bool.isRequired,
  streetViewShow: bool.isRequired,
  cycloramaShow: bool.isRequired,
}

const mapStateToProps = ({ ui, spi, signsState }) => ({
  searchContent: ui.searchContent,
  signs: signsState.signs.length > 0,
  theme: spi.theme,
  listShow: ui.listShow,
  streetViewShow: ui.streetViewShow,
  cycloramaShow: ui.cycloramaShow,
})

const mapDispatchToProps = dispatch => ({
  toggleSearchContent: value => dispatch(toggleSearchContent(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LargeScreenClose)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/CloseSearchContent/LargeScreen.jsx